/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { vendorTicketLogControllerFindAll } from '../fn/vendor-ticket-log/vendor-ticket-log-controller-find-all';
import { VendorTicketLogControllerFindAll$Params } from '../fn/vendor-ticket-log/vendor-ticket-log-controller-find-all';
import { vendorTicketLogControllerSearchOffset } from '../fn/vendor-ticket-log/vendor-ticket-log-controller-search-offset';
import { VendorTicketLogControllerSearchOffset$Params } from '../fn/vendor-ticket-log/vendor-ticket-log-controller-search-offset';
import { VendorTicketLogDto } from '../models/vendor-ticket-log-dto';

@Injectable({ providedIn: 'root' })
export class VendorTicketLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vendorTicketLogControllerFindAll()` */
  static readonly VendorTicketLogControllerFindAllPath = '/api/vendor-ticket-log';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorTicketLogControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorTicketLogControllerFindAll$Response(params?: VendorTicketLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorTicketLogDto>> {
    return vendorTicketLogControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorTicketLogControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorTicketLogControllerFindAll(params?: VendorTicketLogControllerFindAll$Params, context?: HttpContext): Observable<VendorTicketLogDto> {
    return this.vendorTicketLogControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorTicketLogDto>): VendorTicketLogDto => r.body)
    );
  }

  /** Path part for operation `vendorTicketLogControllerSearchOffset()` */
  static readonly VendorTicketLogControllerSearchOffsetPath = '/api/vendor-ticket-log/search/offset';

  /**
   * 입점사 이용권 오프셋 기반 조회.
   *
   * 입점사 이용권 로그를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorTicketLogControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorTicketLogControllerSearchOffset$Response(params: VendorTicketLogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return vendorTicketLogControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 이용권 오프셋 기반 조회.
   *
   * 입점사 이용권 로그를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorTicketLogControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorTicketLogControllerSearchOffset(params: VendorTicketLogControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.vendorTicketLogControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

}
